import { CancelTokenSource } from 'axios';
import { IApplicationScopeRef, IScopeRefCreate } from '../types';
import { ApiRepository } from './main repository/api.repository';

export const getScopeRefs = async (cancelTokenSource: CancelTokenSource): Promise<IApplicationScopeRef[]> => {
  return ApiRepository.Core().get(
    `${window.globalConfiguration.api.base}/v1/scopeRefs`,
    { withChildren: true },
    { cancelToken: cancelTokenSource.token }
  );
};

export const createScopeRef = async (
  cancelTokenSource: CancelTokenSource,
  scopeRef: IScopeRefCreate
): Promise<IApplicationScopeRef> => {
  return ApiRepository.Core().post(`${window.globalConfiguration.api.base}/v1/scopeRefs`, scopeRef, undefined, {
    cancelToken: cancelTokenSource.token,
  });
};

export const updateScopeRef = async (
  cancelTokenSource: CancelTokenSource,
  scopeRef: Partial<IApplicationScopeRef>,
  id: number
): Promise<IApplicationScopeRef> => {
  return ApiRepository.Core().put(`${window.globalConfiguration.api.base}/v1/scopeRefs/${id}`, scopeRef, undefined, {
    cancelToken: cancelTokenSource.token,
  });
};
